<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Nuevo Incoterms® 2020 / Add Incoterms® 2020</h5>
    <div mat-dialog-content>
      <!--begin::Form-->
      <form class="form" [formGroup]="newIncotermForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
          <br-alert *ngIf="showAlert"></br-alert>
          <p><strong>ID: </strong>1</p>
          <p><strong>Fecha de creación / Date: </strong>{{date | date: 'MMMM d, y'}}</p>
          <mat-form-field class="w-100">
            <mat-label>Descripcipon / Description</mat-label>
            <input matInput type="text" placeholder="ej. Libre a bordo (puerto de carga convenido)"
              formControlName="description" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('description', 'required')">
              <strong>Campo requerido / Field Required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Incoterms® 2020</mat-label>
            <input matInput type="text" placeholder="ej. FOB"
              formControlName="incoterm" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('incoterm', 'required')">
              <strong>Campo requerido / Field Required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <!--end::Form-->
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick(false)">Cerrar / Cancel</button>
      <button mat-button cdkFocusInitial (click)="submit(newIncotermForm)">Guardar / Save</button>
    </div>
  </div>
